import { Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import * as JSTool from '../store/JSTool';
import { settingActions, settingObj } from '../store/SettingSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";

export default function BorderView(props) {

    const settingData = useSelector(state => state.settingData);
    const dispatch = useDispatch();

    return (
        <Stack sx={{
            position: 'absolute',
            width: 1,
            height: settingData.height,
            zIndex: 2,
            pointerEvents: 'none',
            flexDirection: 'row',
            filter: `invert(${(settingData.navIndex == 1 || settingData.navIndex == 3) ? 1 : 0})`,
            opacity: 0.7,
            visibility: settingData.isMobile && 'hidden',
        }}>
            <Stack sx={{
                width: 1,
                overflow: 'hidden',
                position: 'relative',
                bgcolor: '#000fff00',
                mt: '60rem',
                mb: settingData.navIndex == 3 && '100rem',
            }}>
                {/* 上左 */}
                <Box component={'img'}
                    src={JSTool.getImgPath('linxing.png')}
                    sx={{
                        width: '25rem',
                        position: 'absolute',
                        left: '15rem',
                        mt: '13rem',
                    }} />

                <Box component={'img'}
                    src={JSTool.getImgPath('linxing.png')}
                    sx={{
                        width: '25rem',
                        position: 'absolute',
                        right: '15rem',
                        mt: '13rem',
                    }} />

                <Box
                    sx={{
                        width: 1,
                        height: '1px',
                        position: 'absolute',
                        bgcolor: '#ffffff66',
                        mt: '25rem',
                    }} />
                <Box
                    sx={{
                        width: '1px',
                        height: 1,
                        position: 'absolute',
                        bgcolor: '#ffffff66',
                        ml: '28rem',
                    }} />

                {/* 下右 */}
                <Box component={'img'}
                    src={JSTool.getImgPath('linxing.png')}
                    sx={{
                        width: '25rem',
                        position: 'absolute',
                        bottom: 0,
                        left: '15rem',
                        mb: '10rem',
                    }} />

                <Box component={'img'}
                    src={JSTool.getImgPath('linxing.png')}
                    sx={{
                        width: '25rem',
                        position: 'absolute',
                        bottom: 0,
                        right: '15rem',
                        mb: '10rem',
                    }} />


                {/* 底部 */}
                <Stack
                    sx={{
                        width: 1,
                        justifyContent: 'center',
                        flexDirection: 'row',
                        alignItems: 'center',
                        bottom: '22rem',
                        position: 'absolute',
                    }}>
                    <Box
                        sx={{
                            flex: 1,
                            height: '1px',
                            bgcolor: '#ffffff66',
                        }} />
                    <Box
                        sx={{
                            width: settingData.navIndex == 3 ? 0 : '160rem',
                            height: '1px',
                        }} />
                    <Box
                        sx={{
                            flex: 1,
                            height: '1px',
                            bgcolor: '#ffffff66',
                        }} />
                </Stack>


                {/* 右边 */}
                <Stack
                    sx={{
                        width: '1px',
                        height: 1,
                        justifyContent: 'center',
                        alignItems: 'center',
                        right: '28rem',
                        position: 'absolute',
                    }}>
                    <Box
                        sx={{
                            flex: settingData.navIndex == 3 ? 1.7 : 1,
                            width: '1px',
                            bgcolor: '#ffffff66',
                        }} />
                    <Box
                        sx={{
                            height: '350rem',
                            width: '1px',
                        }} />
                    <Box
                        sx={{
                            flex: settingData.navIndex == 3 ? 0.8 : 1,
                            width: '1px',
                            bgcolor: '#ffffff66',
                        }} />
                </Stack>


            </Stack>
        </Stack>
    );
}